import PropTypes from 'prop-types';
import { DisplayInformationPropType } from '../prop-types/display-information';

export const LabelProviderPropType = PropTypes.shape({
  sellerLabelProviderId: PropTypes.string,
  labelProviderId: PropTypes.string,
  carrierId: PropTypes.string,
  name: PropTypes.string,
  displayInformation: DisplayInformationPropType,
});

/**
 * @typedef {object} LabelProviderPropType
 * @property {string} sellerLabelProviderId
 * @property {string} labelProviderId
 * @property {string} carrierId
 * @property {string} name
 * @property {DisplayInformationPropType} displayInformation
 */
